import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AccountApi } from "../../../api/AccountApi";

interface userV2Props {
  users: any[];
  allUsers: any[];
  loginUser: any;
  assigneeCachedData: any;
  loginUserQr: any;
  usersStatus: "idle" | "loading" | "succeeded" | "failed";
  loginUserStatus: "idle" | "loading" | "succeeded" | "failed";
  loginUserQrStatus: "idle" | "loading" | "succeeded" | "failed";
}

const initialState: userV2Props = {
  users: [], // activeUSer
  allUsers: [],
  loginUser: null,
  assigneeCachedData: {},
  loginUserQr: null,
  usersStatus: "idle",
  loginUserStatus: "idle",
  loginUserQrStatus: "idle",
};

export const fetchUsersV2 = createAsyncThunk(
  "userV2Slice/fetchUsersV2",
  async () => {
    const res = await AccountApi.getUsersModule({
      params: { selector: true },
    });
    return res;
  }
);

export const fetchLoginUserV2 = createAsyncThunk(
  "userV2Slice/fetchLoginUserV2",
  async (userId: number) => {
    const res = await AccountApi.getUserInfoV2ById(userId);
    return res;
  }
);

export const fetchLoginUserQr = createAsyncThunk(
  "userV2Slice/fetchLoginUserQr",
  async () => {
    const res = await AccountApi.getLoginUserQrCodes();
    return res;
  }
);

const userV2Slice = createSlice({
  name: "userV2Slice",
  initialState,
  reducers: {
    updateUsers(state, action: PayloadAction<any>) {
      state.users = action?.payload?.data?.filter((x: any) => x?.status === 1);
      state.allUsers = action?.payload?.data;
      state.usersStatus = "succeeded";
    },
    updateLoginUser(state, action: PayloadAction<any>) {
      state.loginUser = action?.payload?.data;
      state.loginUserStatus = "succeeded";
    },
    updateQr(state, action: PayloadAction<any>) {
      state.loginUserQr = action?.payload?.data;
      state.loginUserQrStatus = "succeeded";
    },

    storeNewAsigneeCachedData(state, action: PayloadAction<any>) {
      const key = action?.payload?.data?.key;
      const newData = action?.payload?.data?.newData;
      state.assigneeCachedData = {
        ...state.assigneeCachedData,
        [key]: newData,
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUsersV2.pending, (state) => {
        state.usersStatus = "loading";
      })
      .addCase(fetchUsersV2.fulfilled, (state, action) => {
        state.users = action?.payload?.data?.filter(
          (x: any) => x?.status === 1
        );
        state.allUsers = action?.payload?.data;
        state.usersStatus = "succeeded";
      })
      .addCase(fetchUsersV2.rejected, (state) => {
        state.usersStatus = "failed";
      })
      .addCase(fetchLoginUserV2.pending, (state) => {
        state.loginUserStatus = "loading";
      })
      .addCase(fetchLoginUserV2.fulfilled, (state, action) => {
        state.loginUser = action?.payload?.data;
        state.loginUserStatus = "succeeded";
      })
      .addCase(fetchLoginUserV2.rejected, (state) => {
        state.loginUserStatus = "failed";
      })
      .addCase(fetchLoginUserQr.pending, (state) => {
        state.loginUserQrStatus = "loading";
      })
      .addCase(fetchLoginUserQr.fulfilled, (state, action) => {
        state.loginUserQr = action?.payload?.data;
        state.loginUserQrStatus = "succeeded";
      })
      .addCase(fetchLoginUserQr.rejected, (state) => {
        state.loginUserQrStatus = "failed";
      });
  },
});

export const getLoginUser = (state: any) => state?.userV2Slice?.loginUser;
export const getUsersListV2 = (state: any) => state?.userV2Slice?.users; //get user active
export const getAllUsersListV2 = (state: any) => state?.userV2Slice?.allUsers; // + user inactive
export const getAuthUserQrCode = (state: any) =>
  state?.userV2Slice?.loginUserQr; // login user Qr code

export const {
  updateUsers,
  updateLoginUser,
  storeNewAsigneeCachedData,
  updateQr,
} = userV2Slice.actions;
export default userV2Slice.reducer;
